import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _get from "@babel/runtime/helpers/get";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { View } from "./View";
export var Control = /*#__PURE__*/function (_View) {
  _inherits(Control, _View);
  var _super = _createSuper(Control);
  function Control() {
    var _this;
    _classCallCheck(this, Control);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "moveSteps", []);
    _defineProperty(_assertThisInitialized(_this), "moveKeyframeId", null);
    _defineProperty(_assertThisInitialized(_this), "animationHandlerId", null);
    _defineProperty(_assertThisInitialized(_this), "stopMovements", function () {
      if (_this.moveKeyframeId) {
        cancelAnimationFrame(_this.moveKeyframeId);
        _this.moveKeyframeId = null;
      }
    });
    _defineProperty(_assertThisInitialized(_this), "clearMoveQueue", function () {
      _this.moveSteps.length = 0;
      _this.stopMovements();
    });
    _defineProperty(_assertThisInitialized(_this), "keyframeMove", function (x, y) {
      _this.moveSteps.push({
        x: x,
        y: y
      });
      if (!_this.moveKeyframeId) {
        _this.moveKeyframeId = requestAnimationFrame(_this.keyframeMoveHandler);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "keyframeMoveHandler", function () {
      _this.stopMovements();
      var moves = _this.moveSteps.splice(0, _this.moveSteps.length);
      _this.moveKeyframeId = null;
      var x = moves.reduce(function (acc, next) {
        return acc + next.x;
      }, _this.container.scrollLeft);
      var y = moves.reduce(function (acc, next) {
        return acc + next.y;
      }, _this.container.scrollTop);
      _this.container.scrollLeft = x;
      _this.container.scrollTop = y;
    });
    _defineProperty(_assertThisInitialized(_this), "transition", function (x, y) {
      var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 250;
      var startTime = Date.now();
      var getCoordChangeFn = function getCoordChangeFn(start, end) {
        return function () {
          var time = Date.now();
          var timePoint = (time - startTime) / duration;
          var done = timePoint >= 1;
          return {
            done: done,
            value: done ? end : start + (end - start) * timePoint
          };
        };
      };
      var xAnimationFn = getCoordChangeFn(_this.container.scrollLeft, x);
      var yAnimationFn = getCoordChangeFn(_this.container.scrollTop, y);
      _this.clearMoveQueue();
      _this.animationHandlerId = requestAnimationFrame(function () {
        return _this.transitionHandler(xAnimationFn, yAnimationFn);
      });
    });
    _defineProperty(_assertThisInitialized(_this), "transitionHandler", function (xFn, yFn) {
      var xResult = xFn();
      var yResult = yFn();
      _this.move(xResult.value, yResult.value);
      if (!(xResult.done && yResult.done)) {
        _this.animationHandlerId = requestAnimationFrame(function () {
          return _this.transitionHandler(xFn, yFn);
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "animation", function (xFn, yFn) {
      var xResult = xFn();
      var yResult = yFn();
      _this.move(xResult.value(_this.container.scrollLeft - _this.state.gutterHorizontal, _this.scrollWidth - _this.state.gutterHorizontal * 2) + _this.state.gutterHorizontal, yResult.value(_this.container.scrollTop - _this.state.gutterVertical, _this.scrollHeight - _this.state.gutterVertical * 2) + _this.state.gutterVertical);
      if (!(xResult.done && yResult.done)) {
        _this.animationHandlerId = requestAnimationFrame(function () {
          return _this.animation(xFn, yFn);
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "move", function (x, y) {
      _this.clearMoveQueue();
      _this.container.scrollLeft = x;
      _this.container.scrollTop = y;
    });
    return _this;
  }
  _createClass(Control, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.clearMoveQueue();
      cancelAnimationFrame(this.animationHandlerId);
      _get(_getPrototypeOf(Control.prototype), "componentWillUnmount", this).call(this);
    }
  }]);
  return Control;
}(View);